module.exports = __webpack_public_path__ + "img/document-primary.5bc9c5c.svg?v=1764327952164";